import { Box, Popover, TextField, useTheme } from "@mui/material";
import { format, isWithinInterval } from "date-fns";
import { useState } from "react";
import { DayPicker } from "react-day-picker";
import { TextFieldStyles } from "../../styles/commonStyles";
import { it } from "date-fns/locale";

import "react-day-picker/style.css";

const CustomDatePicker = ({
  label,
  id,
  selectedDate,
  handleDateSelect,
  disabledDays = [],
  customStyle,
  error,
  disabledRanges = [],
  disabled,
  toYear = 2050,
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleDateChange = (date) => {
    if (date) {
      handleDateSelect(date);
      handleClose();
    } else {
      handleClose();
    }
  };

  const isDateDisabled = (date) => {
    return disabledRanges.some((range) =>
      isWithinInterval(date, { start: range.start, end: range.end })
    );
  };

  return (
    <>
      <TextField
        variant="filled"
        id={id}
        label={label}
        placeholder="gg/mm/aaaa"
        fullWidth
        value={selectedDate ? format(selectedDate, "dd/MM/yyyy") : ""}
        InputLabelProps={{ shrink: Boolean(selectedDate) || undefined }}
        onClick={handleOpen}
        sx={customStyle || TextFieldStyles}
        error={!!error}
        helperText={error}
        disabled={disabled}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box p={2}>
          <DayPicker
            mode="single"
            selected={selectedDate}
            onSelect={handleDateChange}
            locale={it}
            weekStartsOn={1}
            disabled={[isDateDisabled, disabledDays]}
            style={{
              "--rdp-accent-color": theme.palette.primary.main,
            }}
            captionLayout="dropdown"
            endMonth={new Date(toYear, 12)}
          />
        </Box>
      </Popover>
    </>
  );
};

export default CustomDatePicker;
